module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"missing_required_fields":"다음 조건을 만족하지 않아 적립금을 받을 수 없어요."}}')
  delete Component.options._Ctor
}
